import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Imperiality_table from "./imperiality_table/Imperiality_table";

function Imperiality() {
  return (
    <>
      <section className="Imperiality">
        <div className="back_div">
          <Common_Back_Btn backText="Imperiality" />
        </div>

        <div className="imperiality_table_div">
          <Imperiality_table />
        </div>
      </section>
    </>
  );
}

export default Imperiality;
